<div class="row mb-2">
  <div class="col">
    <div class="select-wrapper">
      <select #listSelect class="form-select">
        <option [ngValue]="null" selected disabled>
          Изберете механизация
        </option>
        <ng-container *ngFor="let m of _availableMechanisationsList">
          <ng-container *ngIf="m.isActive">
            <option [value]="m.id">{{ m.title }}</option>
          </ng-container>
        </ng-container>
      </select>
      <button
        type="button"
        class="btn btn-primary"
        [disabled]="!listSelect.value"
        (click)="onAddMechanisationClicked(+listSelect.value); listSelect.selectedIndex = 0"
      >
        Добави
      </button>
    </div>
  </div>
</div>
<ng-container *ngIf="_usedEmergencyMechanisationsList.length">
  <div class="row mb-3">
    <div class="col">
      <table class="table table-sm table-reset table-hover">
        <thead>
          <tr>
            <th scope="col">Име на механизация</th>
            <th scope="col">Описание</th>
            <th scope="col">Налично количество</th>
            <th scope="col" class="quantity-input-col">Нужна бройка</th>
            <th scope="col" class="edit-action-col">Редакция</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let em of _usedEmergencyMechanisationsList">
            <tr>
              <td>{{em.mechanisation?.title}}</td>
              <td>{{em.mechanisation?.description}}</td>
              <td>{{em.mechanisation?.totalQuantity}}</td>
              <td class="quantity-input-col">
                <input
                  [(ngModel)]="em.quantityUsed"
                  [ngModelOptions]="{standalone: true}"
                  class="form-control"
                  type="number"
                  min="0"
                  max="{{em.mechanisation?.totalQuantity}}"
                />
              </td>
              <td class="edit-action-col">
                <button
                  class="grid-btn btn btn-danger btn-sm"
                  ngbTooltip="Натиснете тук за да редактирате материала."
                  placement="top"
                  (click)="onDeleteEmergencyMechanisationClicked(em, $event); listSelect.selectedIndex = 0"
                >
                  <i class="fa fa-trash-o"></i>
                </button>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</ng-container>
